<script lang="ts">
    import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
    import IconComponent from "@/components/atoms/Icon.vue";
    import { IconName } from "webshop-modules";

    @Component({
        components: {IconComponent},
        name: 'BottomPanel',
    })
    export default class BottomPanel extends Vue {
        @Prop() title = '';
        @Prop() maxHeight = '80vh';
        @Prop() triggerDestroyPanel = false;

        @Emit()
        public destroyPanel(): boolean {
            return true;
        }

        @Watch('triggerDestroyPanel')
        public closePanel(): void {
            this.panelVisible = false;
        }

        public readonly IconName = IconName;

        public panelVisible = false;

        private mounted(): void {
            this.panelVisible = true;
        }
    }
</script>

<template>
    <transition name="backdrop" @after-leave="destroyPanel">
        <div class="m-bottomPanel__container body__no-scroll" v-show="panelVisible">
            <div class="m-bottomPanel__backdrop" v-on:click="closePanel"></div>

            <div class="m-bottomPanel__contentContainer" :style="{ maxHeight }">
                <div class="m-bottomPanel__header">
                    <div class="m-bottomPanel__headerText">{{ title }}</div>
                    <div class="m-bottomPanel__iconContainer">
                        <IconComponent v-on:click="closePanel" :icon-id="IconName.Close"/>
                    </div>
                </div>

                <div data-js="panel-content" class="m-bottomPanel__content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>
